import { Form, Spin, Tabs } from 'antd';
import { useEffect, useState } from 'react';

import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import type React from 'react';
import { useForm } from 'antd/lib/form/Form';
import Invoice from './Invoice/Invoice';
export type AnomalyManagementProps = {
  color: string;
};
const AnomalyManagement = ({ color }: AnomalyManagementProps) => {
  const [form] = useForm();
  const [activeTabKey, setActiveTabKey] = useState<string>('1'); // Track active tab

 

  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  // Callback for when a tab is activated
  const handleTabActivated = (tabKey: string) => {
    console.log(`Tab ${tabKey} activated and data refreshed`);
  };

  return (
    <DF.Provider pagcode="paymentsfs">
      <Spin spinning={false}>
        <Form layout="vertical" form={form}>
          <Tabs
            className="tabs-border-top"
            activeKey={activeTabKey}
            onChange={handleTabChange}
          >
            <Tabs.TabPane
              forceRender
              tab={<GetLabel label="invoice" className="font-size-15" />}
              key="1"
            >
             <Invoice color={color}/>
            </Tabs.TabPane>
          
            
           
          </Tabs>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default AnomalyManagement;
